import Organization from 'models/admin/organization';
import Employee from 'models/employee';
import HashTag from 'models/hashtag';

export const getOrganizationObjectFromRes = (res) => {
  const org = new Organization();
  org.fromJSON(res);
  return org;
};

export const getOrganizationTagObjectFromRes = (res) => {
  const orgTag = new HashTag();
  orgTag.fromJSON(res);
  return orgTag;
};

export const getCompetenciesFromRes = (res) => {
  const orgTag = new HashTag();
  orgTag.fromJSON(res.organizationTag);
  return { ...orgTag, jobFunctionRole: res.jobFunctionRole };
};

/* Employees Settings */

export const getEmployeeObjectFromRes = (res) => {
  const employee = new Employee();
  employee.fromJSON(res);
  employee.managerEmail = res.metadata.managerEmail;

  return employee;
};

const employeeSecondaryPods = (secondaryPods, empEmail) =>
  secondaryPods.reduce(
    (stateObj, { label }) => ({
      ...stateObj,
      [label]: [empEmail],
    }),
    {}
  );

export const formatPrimaryAndSecondaryPodForAPICall = (employee) => {
  const employeeObject = {
    ...employee,
    primaryPod: employee.primaryPod && {
      [employee.primaryPod.label]: [employee.email],
    },
    secondaryPods: employee.secondaryPods && employeeSecondaryPods(employee.secondaryPods, employee.email),
    customFields: employee.metadata?.customFields,
  };

  return employeeObject;
};
